import { Box, styled, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';

import { ChoiceContainer as FeedbackBox } from '~/views/customer/PricingPlans/components';

type FeedbackMessageBoxProps = {
  message: string | ReactElement;
  severity: 'success' | 'failure';
};

const StyledErrorIcon = styled(ErrorIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '18px',
  display: 'flex',
  alignSelf: 'top',
}));

const StyledCheckCircleIcon = styled(CheckCircleIcon)(({ theme }) => ({
  color: theme.palette.success.main,
  fontSize: '18px',
  display: 'flex',
  alignSelf: 'top',
}));

export const FeedbackMessageBox = ({ message, severity }: FeedbackMessageBoxProps): ReactElement => {
  const Icon = severity === 'success' ? StyledCheckCircleIcon : StyledErrorIcon;

  return (
    <FeedbackBox display="flex" flexDirection="row" gap={1} padding={2}>
      <Icon />
      <Box>
        <Typography textAlign="left">{message}</Typography>
      </Box>
    </FeedbackBox>
  );
};
